import type { PropsWithChildren } from 'react';

type QuoteProps = PropsWithChildren<
  {
    citationName?: string;
    citationTitle?: string;
  } & DataTestIdProp &
    ClassNameProp
>;

const Quote = ({ citationName, citationTitle, className, children, ...props }: QuoteProps) => (
  <blockquote {...props} className={`space-y-16 sm:space-y-32 ${className ? className : ''}`}>
    <div className="relative border-l-1 border-gray-dark pl-32 font-display text-2xl text-gray-darker before:absolute before:-ml-4 before:translate-x-[-100%] before:transform before:content-['\201C'] after:content-['\201D']">
      {children}
    </div>

    <div className="flex flex-col items-end">
      <div className=" relative flex items-center before:mr-16 before:h-1 before:w-32 before:bg-gray-dark">
        <div>
          {citationName && <div className="text-h5">{citationName}</div>}
          {citationTitle && <p className="text-sm text-gray">{citationTitle}</p>}
        </div>
      </div>
    </div>
  </blockquote>
);

export default Quote;
